"use client"

import { Stack, Text, Group, CopyButton, ActionIcon, Alert } from "@forestsync/ui"
import { TbCopy, TbCheck, TbAlertCircle } from "@forestsync/ui"
import { useTranslations } from "next-intl"

export type WireInstructions = {
  bankName: string
  iban: string
  bic: string
  accountHolder: string
  referencePrefix: string
}

export function WireInstructionsBlock({ wireInstructions }: { wireInstructions: WireInstructions | null }) {
  const t = useTranslations("options")

  if (!wireInstructions) {
    return <Alert color="yellow" icon={<TbAlertCircle size={16} />}>{t("wireInstructionsUnavailable")}</Alert>
  }

  return (
    <Stack gap={4}>
      <Text size="sm" fw={600}>{t("wireInstructions")}</Text>
      {([
        ["bankName", wireInstructions.bankName],
        ["iban", wireInstructions.iban],
        ["bic", wireInstructions.bic],
        ["accountHolder", wireInstructions.accountHolder],
      ] as const).map(([key, value]) => (
        <Group key={key} justify="space-between">
          <Text size="xs" c="dimmed">{t(`wire.${key}`)}</Text>
          <Group gap={4}>
            <Text size="sm">{value}</Text>
            <CopyButton value={value}>
              {({ copied, copy }) => (
                <ActionIcon size="xs" variant="subtle" onClick={copy}>
                  {copied ? <TbCheck size={12} /> : <TbCopy size={12} />}
                </ActionIcon>
              )}
            </CopyButton>
          </Group>
        </Group>
      ))}
    </Stack>
  )
}
